import React, { Component } from 'react';
import { translate } from 'react-i18next';
import PropType from 'prop-types';
import PartnerListing from './components/PartnerListing';
import PartnerDetails from './components/PartnerDetails';
import apiService from '../../utils/api/apiService';
import './partners.sass';

/**
 * Page for partner services listing page and partner details.
 * 
 * Few different paths are supported:
 * * /partners - Shows list of all partner services
 * * /partners/#<partnername> - Shows partner details with 'connect with suunto app' -button.
 * * /partners/<partnername>/ - Also shows partner details but this url is also registred as a deep-link in Suunto app.
 * 
 */
export class Partners extends Component {
  state = {
    loading: true,
    data: [],
  };

  componentDidMount() {
    return this.getPartnerListing()
      .then((data) => {
        this.setState(() => ({ loading: false, data: data }));
      })
      .catch((err) => this.setState(() => ({ error: err, loading: false })));
  }

  getPartnerListing() {
     
    // Use 'apiService.request' instead of 'apiService.get' to use specific headers instead of the defaults.
    const requestOptions = {
      headers: { 
        'Accept': 'application/json',
        'Accept-Language': 'en' // Force english to avoid part of partners translated to user browser language
      }
    };
    return apiService.request('partnerconnection', requestOptions)
      .then((res) => {
        const data = [...res.payload.oauth2, ...res.payload.openApi]
          .map((p) => ({
            title: p.localization.viewTitle || p.name,
            subtitle: p.localization.descriptionTitle,
            text: p.localization.descriptionBody,
            icon: p.iconImageUrl,
            id: p.name,
          }))
          .sort((a, b) => a.title.localeCompare(b.title));
        return data;
      });
  }

  // Optimization that prevents an unnecessary full page reload
  onClickPartnerServicesLink(e) {
    e.preventDefault();
    this.props.history.replace('/partners/');
  }

  render() {
    const { t } = this.props;

    const partnerIdInUrl = this.props.match.params.id || null;
    const partnerIdInHash = decodeURIComponent(this.props.location.hash.slice(1)) || null;
    const partnerId = partnerIdInUrl || partnerIdInHash;

    if (!partnerId) {
        return (
            <div className="partners">
                <h1 className="partners-title title">Suunto partners</h1>
                <PartnerListing data={this.state.data} />
            </div>
        )
    }
    
    const partner = this.state.data.find((d) => d.id === partnerId);
    const isConnectButtonVisible = Boolean(partner && partnerIdInHash && !partnerIdInUrl);

    return (
        <div className="partners">
          <a className="partner-services-link" href="/partners/" onClick={this.onClickPartnerServicesLink.bind(this)}>← Suunto partners</a>
          { partner && <PartnerDetails partner={partner} isConnectButtonVisible={isConnectButtonVisible} /> }
          { !partner && !this.state.loading && <h1 className="partner-details-title title is-1">Not found</h1> }
        </div>
    );
  }
}

Partners.defaultProps = {
  t: (str) => str,
};

Partners.propTypes = {
  t: PropType.func,
};

export default translate()(Partners);
